import * as basicLightbox from "basiclightbox";
import "./prism.js";
import "virtual:sugarcube.css";

// Lightbox
Array.from(document.querySelectorAll("[data-lightbox]")).forEach((element) => {
  element.onclick = (e) => {
    e.preventDefault();
    basicLightbox.create(`<img src="${element.href}">`).show();
  };
});
